import { API } from "@/constants/common";
import { apiClient } from "../client/apiClient";
import { DealerMasterParams } from "./type";

export class LoanParamsService {
  static instance: LoanParamsService;

  public static QUERY_KEY = {
    BASE: "loan_params",
    FETCH_ALL: ["loan_params", "fetch_all"],
    DEALER_MASTER: ["loan_params", "dealer_master"],
  };

  constructor() {
    if (LoanParamsService.instance) {
      return LoanParamsService.instance;
    }
    LoanParamsService.instance = this;
  }

  async getDealerMaster(params: DealerMasterParams): Promise<any> {
    const data = await apiClient.get(API.LOAN_PARAMS.DEALER_MASTER, {
      limit: params.limit,
      page: params.page,
    });

    return data;
  }
}
